"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnabledQuestions = void 0;
const FormQuestionType_1 = __importDefault(require("../FormQuestionType"));
const getEnabledQuestions = (parentNode, additionalFilter, array = []) => {
    var _a, _b;
    if ((parentNode === null || parentNode === void 0 ? void 0 : parentNode.enabled) && (!additionalFilter || additionalFilter(parentNode))) {
        if ((parentNode.type === FormQuestionType_1.default.REPETITION ||
            parentNode.type === FormQuestionType_1.default.SECTION ||
            parentNode.type === FormQuestionType_1.default.QUESTIONSET) &&
            !((_a = parentNode === null || parentNode === void 0 ? void 0 : parentNode.subQuestions) === null || _a === void 0 ? void 0 : _a.length)) {
            return array;
        }
        if (!parentNode.root &&
            parentNode.type !== FormQuestionType_1.default.QUESTIONSET &&
            parentNode.title) {
            array.push(parentNode);
        }
        for (let i = 0; i < ((_b = parentNode === null || parentNode === void 0 ? void 0 : parentNode.subQuestions) === null || _b === void 0 ? void 0 : _b.length); i++) {
            const sq = parentNode === null || parentNode === void 0 ? void 0 : parentNode.subQuestions[i];
            (0, exports.getEnabledQuestions)(sq, additionalFilter, array);
        }
    }
    return array;
};
exports.getEnabledQuestions = getEnabledQuestions;
exports.default = exports.getEnabledQuestions;
